import { useContext } from 'react'
import { ModalContext, ModalKey } from 'components/Modals/ModalContext'
import { useSelector } from 'react-redux'
import { useGetCoaches } from 'redux/customHooks/useGetCoaches'
import trainingPeaksAppIcon from 'media/integrations/training_peaks/TrainingPeaks_App_Icon.jpg'

export default function TrainingPeaksWorkoutCalendarEventItem({ eventData }) {

    const coaches = useGetCoaches()

    const { ShowModal } = useContext(ModalContext)

    const userId = useSelector(state => state.user.id)
    const firstName = useSelector(state => state.athleteProfile.firstName)
    const lastName = useSelector(state => state.athleteProfile.lastName)
    const trainingPeaksMappingAssignerCoachId = useSelector(state => state.athleteProfile.trainingPeaksMappingAssignerCoachId)
    const trainingPeaksUserId = useSelector(state => state.athleteProfile.trainingPeaksUserId)

    const GetTrainingPeaksMappingAssignerCoachName = (trainingPeaksMappingAssignerCoachId) => {
        if (trainingPeaksMappingAssignerCoachId === null) return 'Unknown'

        const coach = coaches.find(coach => coach.id === trainingPeaksMappingAssignerCoachId)
        return coach ? `${coach.firstName} ${coach.lastName}` : 'Unknown'
    }

    const OnTrainingPeaksWorkoutClicked = () => {

        if (trainingPeaksMappingAssignerCoachId !== userId) {

            const modalData = {
                key: ModalKey.Text,
                size: 'quarter',
                titleText: 'Unable to open TrainingPeaks calendar',
                bodyText: [
                    firstName + ' ' + lastName + '\'s TrainingPeaks integration is not setup with your account.',
                    'It was connected to ' + GetTrainingPeaksMappingAssignerCoachName(trainingPeaksMappingAssignerCoachId) + '\'s TrainingPeaks account.',
                    'Please contact us at support@kinesisintegrated.com for more information.'
                ],
                buttonText: 'Close',
                buttonAction: () => {}
            }

            ShowModal(modalData)

            return
        }

        var baseUrl = 'https://app.sandbox.trainingpeaks.com'

        if (process.env.REACT_APP_NODE_ENV === 'prod') baseUrl = 'https://app.trainingpeaks.com'
        else if (process.env.REACT_APP_NODE_ENV === 'test') baseUrl = 'https://app.sandbox.trainingpeaks.com'
        else if (process.env.REACT_APP_NODE_ENV === 'dev') baseUrl = 'https://app.sandbox.trainingpeaks.com'
        else baseUrl = 'https://app.sandbox.trainingpeaks.com'

        window.open(baseUrl + '/#calendar/athletes/' + trainingPeaksUserId.toString(),  '_blank')
    }

    return (
        <div 
            onClick={OnTrainingPeaksWorkoutClicked}
        >
            <div className='flex items-center gap-x-1'>
                <img src={trainingPeaksAppIcon} alt='TrainingPeaks App Icon' className='h-4 w-4 rounded-sm' />

                <div className='text-gray-800 text-xxs 2xl:text-xs font-medium whitespace-normal truncate'>{eventData.title}</div>
            </div>
        </div>
    )
}